import "@ant-design/v5-patch-for-react-19"; // Ant Design v5 compatibility patch for React 19
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { App as AntdApp, Layout } from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./i18n"; // Initialize i18n
import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/home/HomePage";
import DepositPage from "./pages/deposit/DepositPage";
import ContactPage from "./pages/contact/ContactPage";
import DepositGuidePage from "./pages/deposit-guide/DepositGuidePage";
import PolicyPage from "./pages/policy/PolicyPage";
import PrivacyPage from "./pages/privacy/PrivacyPage";

const { Content } = Layout;

const App: React.FC = () => {
  return (
    <AntdApp>
      <Router>
        <Layout className="app-layout">
          <Header />
          <Content className="app-content">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/deposit-guide" element={<DepositGuidePage />} />
              <Route path="/dieu-khoan-dieu-kien" element={<PolicyPage />} />
              <Route path="/chinh-sach-bao-mat" element={<PrivacyPage />} />

              {/* Payment page (demo: publicly accessible, no auth) */}
              <Route path="/deposit/:gameId" element={<DepositPage />} />
            </Routes>
          </Content>
          <Footer />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Layout>
      </Router>
    </AntdApp>
  );
};

export default App;
